import React, { useState } from 'react';
import Button from "olive-react-myoneui/lib/Button";
import { calendarIcon101, vCopyIcon, checkCircleIcon, closeCircleIcon } from "../../../constants/icons";
import { useNavigate } from "react-router-dom";
import { Badge } from 'olive-react-myoneui';

const CardEvent = ({
  eventId,
  className,
  eventImage,
  eventType,
  eventIcon,
  eventTitle,
  eventDeadline,
  eventLink,
  eventButton,
  eventStartLink,
  linkToCopy,
  eventStatus,
  eventDefaultImg,
  eventCancelledStatus = false
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const navigate = useNavigate();

  const isExternalLink = (url) => {
      try {
          const link = new URL(url);
          return link.protocol === "http:" || link.protocol === "https:";
      } catch (e) {
          return false;
      }
  };

  const startClickHandler = (param = false, e) => {
      if (eventStartLink && param === false) {
          if (isExternalLink(eventStartLink)) {
              window.location.replace(eventStartLink);
          } else {
              navigate(eventStartLink);
          }
      } else {
        navigate(param);
      }
  };

  const handleCopy = async () => {
    try {
        await navigator.clipboard.writeText(linkToCopy);
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    } catch (err) {
        console.error('Failed to copy: ', err);
    }
  };
  return (
    <div className="myk__course-wrapper">
      <div className={`${className || ""} myk__course-block myk__event-card` + (eventCancelledStatus ? " event-cancelled" : '')}>
        <div className="myk__course-img">
          <img src={eventImage} onError={(e) => (e.target.src = eventDefaultImg)} alt="Event Thumbnail" className="img-fluid" />
        </div>
        <div className="myk__course-desc">
          <div className="myk__event-status">
            {eventStatus === 'Completed' && (
              <Badge variant="success" className="badge-event text-dark bg-success">{eventStatus}</Badge>
            )}
            {eventStatus === 'Incomplete' && (
              <Badge variant="danger" className="badge-event text-dark bg-danger">{eventStatus}</Badge>
            )}
            {eventStatus === 'Ongoing' && (
              <Badge variant="warning" className="badge-event text-dark bg-warning">{eventStatus}</Badge>
            )}
            {eventStatus === 'Not Started' && (
              <Badge variant="secondary" className="badge-event text-dark bg-secondary">{eventStatus}</Badge>
            )}
          </div>
          <div className="myk__event-metadata">
            {eventDeadline && <p>{calendarIcon101} {eventDeadline}</p>}
          </div>
          <h1 key={eventId} onClick={!eventCancelledStatus && eventLink !== '' ? () => startClickHandler(eventLink) : null}>{eventTitle}</h1>
          <div className="myk__event-metadata">
              {!eventCancelledStatus && eventButton &&
              <Button
                  variant="outline"
                  className="btn-round bg-transparent text-white border-white"
                  size="sm"
                  onClick={eventLink !== '' ? () => startClickHandler() : null}
              >
              {eventButton}
              </Button>
              }
              {linkToCopy &&
                <p className="btn-copy text-white mb-0" type="button" onClick={handleCopy}>{vCopyIcon} {isCopied ? 'Copied!' : 'Copy Link'}</p>
              }
              {/* {eventStatus === "completed" && (
                <Button
                  variant="outline"
                  className="btn-round bg-transparent text-white border-white w-100"
                  size="sm"
                  disabled
                >
                {checkCircleIcon} Completed
                </Button>
              )} */}
              {eventCancelledStatus && (
                <Button
                  variant="outline"
                  className="d-flex align-items-center justify-content-center gap-1 btn-round bg-transparent text-white border-white"
                  size="sm"
                  disabled
                >
                {closeCircleIcon} {eventButton}
                </Button>
              )}
          </div>
        </div>
      </div>
      {eventType && 
        <div className={`d-flex align-items-center justify-content-center gap-1 myk__dashboard-course-tag ${eventType ? eventType.toLowerCase() : ''}`}>
          <span className="d-flex align-items-center gap-1">{eventIcon} {eventType}</span>
        </div>
      }
    </div>
  );
}

export default CardEvent;
